<template>
  <div class="md-layout text-center login_biz">

    <div class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <form @submit.prevent="register">
        <signup-card>
          <div class="logoWpr" slot="title"><img src="/img/logo-sm.png" alt="Bizminer small logo"></div>
          <h1 slot="title" class="title login-title mt-4">Account Registration</h1>
          <p slot="title" class="sub_title">Enter your details below to continue</p>
          <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto" slot="content">
            <label>First Name</label>
            <md-field :class="{ 'md-invalid': $v.firstName.$error }">
              <!-- <md-icon>face</md-icon>
              <label>First Name</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.firstName.$model" />
              <span class="md-error" v-if="!$v.firstName.required">
                This field is required
              </span>
            </md-field>

            <label>Last Name</label>
            <md-field :class="{ 'md-invalid': $v.lastName.$error }">
              <!-- <md-icon>face</md-icon>
              <label>Last Name</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.lastName.$model" />
              <span class="md-error" v-if="!$v.lastName.required">
                This field is required
              </span>
            </md-field>

            <label>Email</label>
            <md-field :class="{ 'md-invalid': $v.email.$error }">
              <!-- <md-icon>email</md-icon>
              <label>Email</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.email.$model" />
              <span class="md-error" v-if="!$v.email.required">
                This field is required
              </span>
            </md-field>

            <label>Phone Number</label>
            <md-field class="md-invalid">
              <label class="font-size-small">.</label>
              <md-input v-model="$v.phoneNumber.$model" />
            </md-field>

            <label>Password</label>
            <md-field :class="{ 'md-invalid': $v.password.$error }">
              <!-- <md-icon>lock_outline</md-icon>
              <label>Password</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.password.$model" type="password" />
              <span class="md-error" v-if="!$v.email.required">
                This field is required
              </span>
            </md-field>

            <label>Confirm Password</label>
            <md-field :class="{ 'md-invalid': $v.password_confirmation.$error }">
              <!-- <md-icon>lock_outline</md-icon>
              <label>Confirm Password</label> -->
              <label class="font-size-small">.</label>
              <md-input v-model="$v.password_confirmation.$model" type="password" />
              <span class="md-error" v-if="!$v.password_confirmation.required">
                This field is required
              </span>
              <span class="md-error" v-if="!$v.password_confirmation.sameAsPassword">
                Passwords must be identical
              </span>
            </md-field>
            <md-checkbox v-model="$v.boolean.$model" class="m-0">
              I agree to the <a class="dark-blue-color" @click="termsModal = true">terms and conditions</a>.
            </md-checkbox>
            <div class="info" :class="{ 'md-invalid': $v.boolean.$error }">
              <span class="md-error" v-if="!$v.boolean.sameAs" style="color: #ff1744">
                You need to agree with our terms and conditions.
              </span>
            </div>
            <div class="button-container">
              <md-button class="md-info md-round mt-4 dark-blue-color" type="submit" slot="footer">
                Get Started
              </md-button>
            </div>
            <p slot="footer" class="sub_title text-center">Already have an account? <router-link class= "dark-blue-color" to="login">Login
              </router-link>
            </p>
          </div>
        </signup-card>
      </form>
    </div>
      <Modal class="report_inputs" v-if="termsModal" @close="termsModal= false">
     
      <template slot="body">
      
            <Terms />
        
      </template>
    </Modal>
  </div>
</template>
<script>
import { SignupCard,Modal } from "@/components";
import Terms from '@/pages/Bizminer/Terms.vue';
import formMixin from "@/mixins/form-mixin";
import { required, sameAs } from "vuelidate/lib/validators";
import sha256 from "crypto-js/sha256";
import axios from 'axios';

export default {
  components: {
    SignupCard,
    Terms,
    Modal,
  },
  mixins: [formMixin],
  data() {
    return {
      
      termsModal: false,
      firstName: null,
      lastName: null,
      boolean: false,
      email: null,
      password: null,
      password_confirmation: null,
      phoneNumber: null,
      currentSession: null,
    };
  },
  computed: {
    entryURL() {
      return this.$store.getters.productType;
    },
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    email: {
      required,
    },
    password: {
      required,
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs("password"),
    },
    boolean: {
      sameAs: sameAs(() => true),
    },
    phoneNumber: {

    }
  },
  methods: {
    async register() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$store.dispatch("alerts/error", "Please enter inputs!");
        return false;
      } else {
        this.$store.dispatch("getRandomString", 20).then(async (res) => {
          this.currentSession = res;

          let error = true;
          try {
            await axios
              .post(
                process.env.VUE_APP_API_BASE_URL + '/user/register',
                {},
                {
                  params: {
                    session_id: this.currentSession,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    password: this.password,
                    tos: this.boolean ? 1 : 0,
                    phoneNumber: this.phoneNumber,
                  },
                }
              )
              .then((res) => {
               
                if (res.hasOwnProperty('data') && res.data.error && res.data.errorCode !== 'user_already_registered') {
                 
                  this.$store.commit('SET_ERROR_BIT', true);
                  this.$store.commit(
                    'SET_ERROR_INFO',
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/register" <br>`
                  );
                  throw new Error(
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                  );
                }
                else if (res.hasOwnProperty('data') && res.data.error && res.data.errorCode === 'user_already_registered') {
                  this.$store.dispatch(
                    "alerts/error",
                    "Oops, user already registered"
                  );
                }
                else  
                  error = false;

              });
          } catch (e) {
            this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong"
            );
          }
          if (!error)
            this.$router.push({ name: 'EmailSent' });
        });
      }
    }
    /* async register() {
       this.$v.$touch();
       if (this.$v.$invalid) {
         await this.$store.dispatch("alerts/error", "Please enter inputs!");
         return false;
       } else {
         this.$store.dispatch("getRandomString", 20).then(async (res) => {
           const user = {
             session_id: res,
             firstName: this.firstName,
             lastName: this.lastName,
             email: this.email,
             password: sha256(this.password).toString(),
           };
 
           const requestOptions = {
             headers: {
               Accept: "application/vnd.api+json",
               "Content-Type": "application/vnd.api+json",
             },
           };
 
           try {
             await this.$store.dispatch("register", { user, requestOptions });
           } catch (e) {
             await this.$store.dispatch(
               "alerts/error",
               "Oops, something went wrong"
             );
           }
         });
       }
     },*/


  },
};
</script>

<style lang="scss">
.register-page.page-header {
  >.container {
    padding: 0 !important;

    .info {
      margin-top: 10px;
      font-weight: 400;
    }
  }

  footer {
    .container {
      justify-content: center;

      nav {
        display: none;
      }

      .copyright {
        color: #133a64;
      }
    }
  }
}
</style>
<style scoped>
.main-navbar {
  display: none;
}
</style>